import React, { useState, useEffect } from "react";
import Loader from "../../components/Loader";
import moment from "moment";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import {
    Box, Button, Checkbox, Container, FormControl, FormControlLabel,
    FormHelperText, Grid, InputLabel, MenuItem, Select, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, TextField, Typography,
    Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions,
    IconButton, Icon, Tooltip
} from "@mui/material";
import { Search, List, GridView, StarOutline, Star, Share, Delete, Edit, Close, Save, Cancel } from "@mui/icons-material";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../components/toast';
import { axiosDelete, axiosGet, axiosPost } from "../../utils/Axios";
import { getFillListUrl, InsertUserDetailsUrl, GetUserDetailsUrl, DeleteDashboardUserUrl, DeleteUserUrl, UpdateUserDetailsUrl, dashboardUserCountryActionID, mstRoleActionID, dashboardAccessRightActionID } from "../../utils/constants";
import CommonPagination from "../../components/CommonPagination";
import { HeaderBlock } from "@colliers/colliers-b2c";

const ColliersUserManage = () => {
    const [isLoading, setIsLoading] = useState(false);

    const { ToastComponent, showToast } = useToast();

    const { t } = useTranslation();

    const location = useLocation();
    const userID = location?.state?.userID ?? null;
    const [isEdit, setIsEdit] = useState(false);
    const navigate = useNavigate();

    const [validate, setValidate] = useState(false);

    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo == null) {
            navigate('/login/KeyStone_Login');
            return;
        } else {
            fetchData();
            if (userID) {
                setIsEdit(true);
            }
        }
    }, [userID]);

    const [countryList, setCountryList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [countryID, setCountryID] = useState("0");
    const handleCountryChange = (event) => {
        const selectedCountryID = event.target.value;
        setCountryID(selectedCountryID);
        if (selectedCountryID > 0) {
            const updatedCountries = accessCountries.map((country) =>
                country.code === selectedCountryID
                    ? { ...country, defaultChecked: true } // Update the matched country
                    : country
            );
            setAccessCountries(updatedCountries);
        }
    };
    const handleAccessCountryChange = (code, checked) => {
        if (code == countryID && !checked) {
            setCountryID("0");
        }
        if (!checked) {
            const updatedCountries = accessCountries.map((country) =>
                country.code === code
                    ? { ...country, defaultChecked: false } // Update the matched country
                    : country
            );
            setAccessCountries(updatedCountries);
        }
        else if (checked) {
            const updatedCountries = accessCountries.map((country) =>
                country.code === code
                    ? { ...country, defaultChecked: true } // Update the matched country
                    : country
            );
            setAccessCountries(updatedCountries);
        }
    }
    const [roleID, setRoleID] = useState("0");
    const handleRoleChange = (event) => {
        setRoleID(event.target.value);
    };
    const [accessRightList, setAccessRightList] = useState([]);
    const [accessCountries, setAccessCountries] = useState([]);

    const fetchData = async () => {
        setIsLoading(true);
        let updatedAccessCountries = [];
        let updatedAccessRights = [];
        try {
            const data = await axiosGet(getFillListUrl, {
                actionID: dashboardUserCountryActionID,
                valueID: location.state?.userID ? location.state.userID : 0,
                keyValue: null
            });
            if (data != null && data.length > 0) {
                setCountryList(data);
                updatedAccessCountries = data.map(item => ({
                    ...item,
                    defaultChecked: false
                }));
                setAccessCountries(updatedAccessCountries);
            }
            else {
                console.error("Failed to fetch country list: No data found.");
            }
            const roledata = await axiosGet(getFillListUrl, {
                actionID: mstRoleActionID,
                valueID: null,
                keyValue: null
            });
            if (roledata != null && roledata.length > 0) {
                setRoleList(roledata);
            }
            else {
                console.error("Failed to fetch role list: No data found.");
            }
            const accessRightdata = await axiosGet(getFillListUrl, {
                actionID: dashboardAccessRightActionID,
                valueID: null,
                keyValue: null
            });
            if (accessRightdata != null && accessRightdata.length > 0) {
                updatedAccessRights = accessRightdata.map(item => ({
                    ...item,
                    defaultChecked: false
                }));
                setAccessRightList(updatedAccessRights);
                if (userID) {
                    getUserInfo(updatedAccessCountries, updatedAccessRights);
                }
            }
            else {
                console.error("Failed to fetch access right list: No data found.");
            }
        }
        catch (error) {
            console.error("Error fetching country list or role list or access right list:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const [email, setEmail] = useState("");
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    }
    const [name, setName] = useState("");
    const handleNameChange = (event) => {
        setName(event.target.value);
    }
    const handleAccessRightChange = (code, checked) => {

        if (!checked) {
            const updatedRights = accessRightList.map((right) =>
                right.code === code
                    ? { ...right, defaultChecked: false }
                    : right
            );
            setAccessRightList(updatedRights);
        }
        else if (checked) {
            const updatedRights = accessRightList.map((right) =>
                right.code === code
                    ? { ...right, defaultChecked: true }
                    : right
            );
            setAccessRightList(updatedRights);
        }
    }

    const compareStringIds = (string1, string2) => {
        // Split the strings into arrays
        const array1 = string1.split(",").map(Number); // Convert to numbers if needed
        const array2 = string2.split(",").map(Number);

        // Check if lengths are different
        if (array1.length !== array2.length) return true;

        // Sort both arrays
        const sortedArray1 = array1.sort((a, b) => a - b);
        const sortedArray2 = array2.sort((a, b) => a - b);

        // Compare sorted arrays
        for (let i = 0; i < sortedArray1.length; i++) {
            if (sortedArray1[i] !== sortedArray2[i]) {
                return true; // Return false if any element is different
            }
        }
        return false; // Arrays contain the same items
    };
    const anyCountrySelected = () => {
        return accessCountries.some(country => country.defaultChecked);
    };

    const InsertUser = async () => {
        setValidate(true);

        const accessRightTemp = extractCheckedItems(accessRightList);
        const countryAccessTemp = extractCheckedItems(accessCountries);

        if (!isFormValid(name, roleID, countryID, accessRightTemp, countryAccessTemp)) return;

        setIsLoading(true);
        const userPayload = createUserPayload(name, email, roleID, countryID, userID, accessRightTemp, countryAccessTemp);

        try {
            const response = await axiosPost(userID > 0 ? UpdateUserDetailsUrl : InsertUserDetailsUrl, userPayload);

            if (response.code !== 200) {
                showToast('error', response.responseMsg);
                return;
            }

            handleSuccess(userID);
        } catch (error) {
            console.error(`Error ${userID > 0 ? "updating" : "saving"} user:`, error);
        } finally {
            setIsLoading(false);
        }
    };

    const extractCheckedItems = (list) =>
        list?.filter(x => x.defaultChecked).map(x => x.code).join(",") || "";

    const isFormValid = (name, roleID, countryID, accessRight, countryAccess) => {
        const isValidName = !!name?.trim();
        const isEmailValid = validateEmail() === "";
        const isValidRoleAndCountry = roleID > 0 && countryID > 0;
        const hasAccessRights = !!accessRight && !!countryAccess;

        if (isValidName && isEmailValid && isValidRoleAndCountry && hasAccessRights) return true;

        console.error("Mandatory fields are required");
        return false;
    };

    const createUserPayload = (name, email, roleID, countryID, userID, accessRight, countryAccess) => {
        const basecountryID = countryID && countryID !== "0" ? Number(countryID) : 0;
        const role = roleID && roleID !== "0" ? Number(roleID) : 0;

        const payload = {
            name: name || "",
            emailAddress: email || "",
            roleID: role,
            basecountryID: basecountryID,
            updateuserID: userID || 0,
            accessRight: accessRight,
            countryAccess: countryAccess,
        };

        if (userID > 0) {
            payload.isAccessChanged = compareStringIds(accessRight, originalrightIds);
            payload.isCountryChanged = compareStringIds(countryAccess, originalcountryIds);
        }

        return payload;
    };

    const handleSuccess = (userID) => {
        setValidate(false);
        showToast('success', `Successfully ${userID > 0 ? "Updated" : "Saved"}!`);
        setTimeout(() => navigate('/colliers-user-management'), 1000);
    };
    const [activeDashboard, setActiveDashboard] = useState("");
    const [viewedDashboard, setViewedDashboard] = useState("");
    const [sharedDashboard, setSharedDashboard] = useState("");
    const [dashboards, setDashboards] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const listItemsPerPage = 10;
    const [filteredDashboardLog, setFilteredDashboardLog] = useState(dashboards);
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedDashboardLog = filteredDashboardLog?.slice(startIndex, startIndex + listItemsPerPage);
    const totalItems = filteredDashboardLog?.length;
    const [originalcountryIds, setOriginalcountryIds] = useState("");
    const [originalrightIds, setOriginalrightIds] = useState("");
    const getUserInfo = async (updatedAccessCountries, updatedAccessRights) => {
        setIsLoading(true);
        try {
            const data = await axiosGet(GetUserDetailsUrl, { edituserID: Number(userID) });
            if (data != null) {
                setName(data.userName);
                setEmail(data.emailAddress);
                setCountryID(data.basecountryID);
                setRoleID(data.roleID);
                setActiveDashboard(data.activeDashboard);
                setViewedDashboard(data.viewedDashboard);
                setSharedDashboard(data.sharedDashboard);
                if (data.userCountries != null && data.userCountries != undefined && data.userCountries.length > 0) {
                    const countryIdArray = data.userCountries.map(country => parseInt(country.countryID, 10));
                    let newAccessCountries = updatedAccessCountries.map(item => ({
                        ...item,
                        defaultChecked: false
                    }));
                    newAccessCountries = newAccessCountries.map(x => ({
                        ...x,
                        defaultChecked: countryIdArray.includes(Number(x.code))
                    }));
                    setAccessCountries(newAccessCountries);

                    const countryIdString = countryIdArray.join(',');
                    setOriginalcountryIds(countryIdString);
                }
                if (data.accessRights != null && data.accessRights != undefined && data.accessRights.length > 0) {
                    const rightIdArray = data.accessRights.map(right => parseInt(right.accessRightID, 10));
                    let newAccessRights = updatedAccessRights.map(item => ({
                        ...item,
                        defaultChecked: false
                    }));
            
                    newAccessRights = newAccessRights.map(x => ({
                        ...x,
                        defaultChecked: rightIdArray.includes(Number(x.code))
                    }));
                    setAccessRightList(newAccessRights);

                    const rightIdString = rightIdArray.join(',');
                    setOriginalrightIds(rightIdString);
                }
                setDashboards(data.dashboards);
                setFilteredDashboardLog(data.dashboards);
            }
        }
        catch (error) {
            console.error("Error saving user:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const [dashboardGroupID, setDashboardGroupID] = useState("");
    const [dashboardID, setdashboardID] = useState("");
    const [isDeleteModal, setDeleteModal] = useState(false);

    const toggleDeleteModal = (dashboardGroupID, dashboardID) => {
        if (isDeleteModal) {
            setDeleteModal(false);
            setDashboardGroupID('');
            setdashboardID('');
        } else {
            setDeleteModal(true);
            setDashboardGroupID(dashboardGroupID);
            setdashboardID(dashboardID);
        }
    };
    const handleDelete = async (dashboardGroupID, dashboardID) => {
        try {
            setIsLoading(true);
            const response = await axiosDelete(DeleteDashboardUserUrl, { deleteUserID: userID, deleteADGroupID: dashboardGroupID, dashboardID: dashboardID });
            if (response) {
                showToast('success', 'Successfully Deleted!');
                const updatedDashboards = dashboards.filter(x => Number(x.dashboardID) != Number(dashboardID));
                setDashboards(updatedDashboards);
                setFilteredDashboardLog(updatedDashboards);
                setActiveDashboard(response.activeDashboard);
            } else {
                showToast('error', 'Failed to Delete');
            }
        } catch (error) {
            showToast('error', `Error in Delete Dashboard:, ${error}`)
        } finally {
            setIsLoading(false);
            setDeleteModal(false); // Close the modal after the action
        }
    }
    const [isDisableModal, setDisableModal] = useState(false);
    const toggleDisableModel = async () => {
        if (isDisableModal) {
            setDisableModal(false);
        } else {
            setDisableModal(true);
        }
    }
    const handleDisable = async () => {
        try {
            setIsLoading(true);
            const response = await axiosDelete(DeleteUserUrl, { deleteuserID: userID });
            if (response) {
                showToast('success', 'Successfully Deleted!');
                navigate('/colliers-user-management');
            } else {
                showToast('error', 'Failed to Delete');
            }
        } catch (error) {
            showToast('error', `Error in Delete Dashboard:, ${error}`)
        } finally {
            setIsLoading(false);
            setDisableModal(false); // Close the modal after the action
        }
    }
    const onCancelClick = async () => {
        navigate("/colliers-user-management");
    }
    const validateEmail = () => {
        let check = true;
        let errmsg = "";

        if (email == "" || email == null || !is_email(email)) {
            check = false;
            errmsg = "Invalid Email";
        }
        if (!check) {
            return errmsg;
        }

        return errmsg;
    }
    const is_email = (str) => {

        var validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        
        return validRegex.test(str);
        
    }
    const deriveName = async () => {
        if (email != "" && email != null && is_email(email)) {
            const tempName = email.toString().split("@")[0];
            setName(tempName);
        }
    }
    const formatValidUntilDate = (date, t) => {
        if (!date || date === "") return ""; // Handle empty values

        const parsedDate = moment(date, "DD-MM-YYYY HH:mm:ss"); // 'true' ensures strict parsing
        return parsedDate.isValid() ? parsedDate.format("DD MMM YYYY") : t("common.invalidDate");
    };
    const isInvalidCountry = !countryID || countryID === "0";
    const isNameInvalid = validate && !name; 
    const isInvalidCountryNew = validate && (!countryID || countryID === "0");
    const isInvalidRoleNew = validate && (!roleID || roleID === "0");
    return (
        <>
            {isLoading && <Loader />}
            <HeaderBlock left="" title={t('user_mgmt.colliersUserMgmt')} leftCenterAlign="true" actionsCenterAlign="true" />

            <Box
                id="main" className="full-width padding-right-m padding-left-m padding-bottom-m padding-top-none margin-top-m userMain">
                <Box >
                    <Box className="shadow-0 clientNoBorder" mb={3}>
                        <Card className="padding-top-s padding-left-base shadow-0">
                            <CardContent>
                                <Box className="clientHeight"></Box>
                                {isEdit && (
                                    <Grid container spacing={2} mb={3}>
                                        <Grid item xs={6} sm={3}>
                                            <Box className="text-align-center border-light border-radius-soft padding-xs padding-y-base">
                                                <Typography variant="h5" fontWeight="bold">
                                                    {activeDashboard}
                                                </Typography>
                                                <Typography>{t('user_mgmt.activeDashboards')}</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Box className="text-align-center border-light border-radius-soft padding-xs padding-y-base">
                                                <Typography variant="h5" fontWeight="bold">
                                                    {viewedDashboard}
                                                </Typography>
                                                <Typography>{t('user_mgmt.viewedDashboards')}</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Box className="text-align-center border-light border-radius-soft padding-xs padding-y-base">
                                                <Typography variant="h5" fontWeight="bold">
                                                    {sharedDashboard}
                                                </Typography>
                                                <Typography>{t('user_mgmt.sharedDashboards')}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )}

                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField className="space-lab label-space-top-bot margin-bottom-none"
                                            label={t('user_mgmt.email')}
                                            variant="outlined"
                                            fullWidth
                                            placeholder={t('user_mgmt.addEmail')}
                                            value={email}
                                            onChange={handleEmailChange}
                                            onBlur={deriveName}
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={validate && validateEmail() != ""}
                                            helperText={validate && validateEmail() ? t('user_mgmt.pleaseEnterEmail') : ""}

                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField className="space-lab label-space-top-bot margin-bottom-none"
                                            label={t('user_mgmt.name')}
                                            variant="outlined"
                                            fullWidth
                                            placeholder={t('user_mgmt.enteraName')}
                                            value={name}
                                            onChange={handleNameChange}
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={isNameInvalid}
                                            helperText={isNameInvalid ? t('user_mgmt.pleaseEnterName') : ""}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth >
                                            <TextField className="space-lab label-space-top-bot margin-bottom-none"
                                                label={t('user_mgmt.country')}
                                                onChange={handleCountryChange}
                                                value={countryID}
                                                select
                                                fullWidth
                                                required
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                variant="outlined"
                                                error={isInvalidCountryNew}
                                                helperText={isInvalidCountry ? t('user_mgmt.pleaseSelectCountry') : ""}
                                            >
                                                <MenuItem key="0" value="0">
                                                    {t('user_mgmt.selectCountry')}
                                                </MenuItem>
                                                {countryList.map((item) => (
                                                    <MenuItem key={item.code} value={item.code}>
                                                        {item.description}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl fullWidth>
                                            <TextField
                                                className="space-lab label-space-top-bot margin-bottom-none"
                                                label={t('user_mgmt.role')}
                                                onChange={handleRoleChange}
                                                value={roleID}
                                                select
                                                fullWidth
                                                required
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                variant="outlined"
                                                error={isInvalidRoleNew}
                                                helperText={isInvalidRoleNew ? t('user_mgmt.pleaseSelectRole') : ""}
                                            >
                                                <MenuItem key="0" value="0">
                                                    {t('user_mgmt.selectRole')}
                                                </MenuItem>
                                                {roleList.map((item) => (
                                                    <MenuItem key={item.code} value={item.code}>
                                                        {item.description}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {/* Access Rights */}
                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12} md={5} className="margin-top-xs">
                                        <Typography className="font-size-h5 text-primary-dark margin-bottom-xs text-uppercase padding-top-xs" variant="h6" textTransform="uppercase">
                                            {t('user_mgmt.accessRights')} 
                                        </Typography><Box className="userHeight"></Box>
                                        {accessRightList.map((right, index) => (
                                            <FormControl className="margin-left-xs margin-bottom-s single-line margin-left-none full-width" key={index} 
                                            // error={validate && validateAccess() !== ""}
                                            >
                                                <FormControlLabel className="margin-left-none"
                                                    control={<Checkbox sx={{ marginRight: '-8px' }} checked={right.defaultChecked}
                                                        onChange={(e) => handleAccessRightChange(right.code, e.target.checked)} className="margin-left-none" />}
                                                    label={right.description}
                                                />
                                            </FormControl>
                                        ))}
                                    </Grid>
                                    {/* Accessible Country */}
                                    <Grid item xs={12} md={7} className="margin-top-xs">
                                        <Typography variant="h6" className="font-size-h5 text-primary-dark margin-bottom-xs text-uppercase padding-top-xs" textTransform="uppercase">
                                            {t('user_mgmt.accessibleCountry')} <span className="clientColorRed">&nbsp;*</span>
                                        </Typography>
                                        <div className="userHeight"></div>

                                        {/* Map through the countries and display the checkboxes */}
                                        {accessCountries.map((country, index) => (
                                            <FormControl className="margin-left-xs margin-bottom-s" key={index} error={validate && !anyCountrySelected()}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            sx={{ marginRight: '-8px' }}
                                                            checked={country.defaultChecked}
                                                            onChange={(e) => handleAccessCountryChange(country.code, e.target.checked)}
                                                        />
                                                    }
                                                    label={country.description}
                                                />
                                            </FormControl>
                                        ))}

                                        {/* Show error message only if no country is selected */}
                                        {validate && !anyCountrySelected() && (
                                            <Typography variant="body2" sx={{ fontSize: '11px', color: 'red' }} color="error" className="margin-left-none">
                                                {t('user_mgmt.pleaseSelectOneCountry')}
                                            </Typography>
                                        )}
                                    </Grid>


                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                    {isEdit && (
                        <Box className="border-light padding-y-base padding-x-base border-radius" >
                            {isEdit && (<Typography className="font-size-h5 text-primary margin-bottom-xs text-uppercase padding-top-xs clientColor" variant="h6" textTransform="uppercase" mb={2}>
                                {t('user_mgmt.listOfAccessibleDashboard')}
                            </Typography>)}
                            {isEdit && (<TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('user_mgmt.dashboard')}</TableCell>
                                            <TableCell>{t('user_mgmt.group')}</TableCell>
                                            <TableCell>{t('user_mgmt.accessRights')}</TableCell>
                                            <TableCell>{t('user_mgmt.validTil')}</TableCell>
                                            <TableCell align="center">{t('common.Action')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedDashboardLog?.length? (
                                            paginatedDashboardLog?.map((dashboard, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{dashboard.dashboardName}</TableCell>
                                                    <TableCell>{dashboard.dashboardGroup}</TableCell>
                                                    <TableCell>{dashboard.accessRight}</TableCell>
                                                    <TableCell>{formatValidUntilDate(dashboard.validUntil, t)}</TableCell>
                                                    <TableCell align="center">
                                                        {/*<IconButton onClick={() => toggleDeleteModal(dashboard.dashboardGroupID,dashboard.dashboardID)}>*/}
                                                        {/*    <Delete color="primary" />*/}
                                                        {/*</IconButton>*/}
                                                        <Button className="padding-right-none">
                                                            <Tooltip title="Remove">
                                                                <Icon className='fa-light fa-trash-can text-primary font-size-base  text-primary' onClick={() => toggleDeleteModal(dashboard.dashboardGroupID, dashboard.dashboardID)} />
                                                            </Tooltip>
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))) : (
                                            <TableCell colSpan={5}>{t('common.noRecordsFound')}</TableCell>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>)}
                            {isEdit && (< CommonPagination
                                totalItems={totalItems}
                                currentPage={currentPage}
                                onPageChange={setCurrentPage}
                            />)}
                            <Dialog
                                open={isDeleteModal}
                                className="userDialog"
                            >
                                <DialogTitle>
                                    <Typography className="margin-bottom-none font-size-h3 text-primary text-align-left"
                                        variant="h6"
                                    >
                                        {t('user_mgmt.deleteDashboard')}
                                    </Typography>
                                </DialogTitle>

                                <DialogContent>
                                    <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                        {t('common.deleteMessage')}
                                    </Typography>
                                </DialogContent>

                                <DialogActions className="dialogAction">
                                    <Button className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                                        variant="outlined"
                                        startIcon={<Cancel />}
                                        onClick={() => toggleDeleteModal('', '')}

                                    >
                                        {t('common.Cancel')}
                                    </Button>
                                    <Button className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                                        variant="contained"
                                        onClick={() => handleDelete(dashboardGroupID, dashboardID)}
                                        startIcon={<Delete />}
                                    >
                                        {t('common.Delete')}
                                    </Button>
                                </DialogActions>
                            </Dialog>


                            <Dialog
                                open={isDisableModal}
                                className="userDialog1"
                            >
                                <DialogTitle>
                                    <Typography className="margin-bottom-none font-size-h3 text-primary text-align-left " variant="h6">
                                        {t('user_mgmt.disableUser')}
                                    </Typography>
                                </DialogTitle>

                                {/* <DialogContent>
                                    <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left ">
                                        {t('common.deleteMessage')}
                                    </Typography>
                                </DialogContent> */}

                                <DialogActions className="dialogAction">
                                    <Button
                                        variant="outlined"
                                        startIcon={<Cancel />}
                                        onClick={() => toggleDisableModel()}
                                        className="userDialogButton"
                                    >
                                        {t('common.Cancel')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleDisable()}
                                        startIcon={<Delete />}
                                        className="userDialogButton1"
                                    >
                                        {t('common.Delete')}
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </Box>
                    )}
                </Box>

                <Box className="margin-bottom-l" display="flex" justifyContent="center" mt={2} gap={2}>

                    <Button variant="outlined" color="primary" onClick={InsertUser}>
                        {t('common.Save')}
                    </Button>
                    <Button variant="outlined" color="primary" onClick={onCancelClick}>
                        {t('common.Cancel')}
                    </Button>
                    {isEdit && (<Button variant="outlined" color="error" onClick={toggleDisableModel}>
                        {t('common.disable')}
                    </Button>)}
                </Box>




            </Box>
            {ToastComponent}
        </>
        //  )}
        //</>
    );
};

export default withTranslation()(ColliersUserManage);
